<div class="flex-direction-column gap-15 width-99 position-relative">
  @if (custos.length > 0 && !carregando) {
    <mat-table [dataSource]="dataSource" style="width: 100%; overflow: auto;">
      <ng-container matColumnDef="acao">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                             widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(elemento)"></app-button-padrao>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="pais">
        <mat-header-cell *matHeaderCellDef> País </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ nomePais(elemento.codigoPais) }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="categoria">
        <mat-header-cell *matHeaderCellDef> Categoria </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ nomeCategoria(elemento.categoriaCobranca) }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="custo">
        <mat-header-cell *matHeaderCellDef> Custo </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.moeda }} {{ elemento.custo }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="criadoPor">
        <mat-header-cell *matHeaderCellDef> Criado por </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="(elemento.createdAt | date:'dd/MM/yyyy - HH:mm') || ''" class="ellipse">
            {{ elemento.createdByNome || '-' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="alteradoPor">
        <mat-header-cell *matHeaderCellDef> Alterado por </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="(elemento.updateAt | date:'dd/MM/yyyy - HH:mm') || ''" class="ellipse">
            {{ elemento.updatedByNome || '-' }}
          </span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  } @else if (custos.length <= 0 && !carregando) {
    <div class="flex center-center height-100">
      <span class="label">Nenhum custo de mensagem WhatsApp cadastrado.</span>
    </div>
  } @else if (carregando) {
    <app-tabela-skeleton [qntdLinhas]="5"></app-tabela-skeleton>
  }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" alt="Adicionar custo" role="button" tabindex="0" (click)="abrirModal()" (keydown.enter)="abrirModal()" />
</div>
